var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxBoldFolderCloud(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.579 19.699c-2.11.15-2.11 3.21 0 3.36h5.01c.61 0 1.19-.22 1.64-.63 1.48-1.29.69-3.89-1.26-4.13-.7-4.22-6.81-2.62-5.36 1.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.579 19.699c-2.11.15-2.11 3.21 0 3.36h5.01c.61 0 1.19-.22 1.64-.63 1.48-1.29.69-3.89-1.26-4.13-.7-4.22-6.81-2.62-5.36 1.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22 15.34c0 .32-.51.46-.73.23-.47-.49-1.06-.86-1.74-1.07-1.57-.49-3.38-.01-4.52 1.17-.72.77-1.11 1.73-1.13 2.77 0 .18-.09.34-.23.45-.72.57-1.16 1.46-1.16 2.48v.01c0 .32-.23.61-.55.61h-4.6C4.4 22 2 19.6 2 16.65V6.42C2 3.98 3.98 2 6.42 2h2.32c1.63 0 2.14.53 2.79 1.4l1.4 1.86c.31.41.35.46.93.46h2.79c2.38 0 4.4 1.56 5.09 3.72.15.45.23.91.25 1.4.01.07.01.16.01.23v4.27z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxBoldFolderCloud);
export default __webpack_public_path__ + "static/media/vuesax-bold-folder-cloud.f5e0a4e2a3bb710b13c028f17339d549.svg";
export { ForwardRef as ReactComponent };